(ns kyber.kyber-db.moment)

(def model
  {:ident-key
   :moment/uuid

   :refs
   {:moment/question
    {:model :question
     :cardinality :one}

    :moment/resources
    {:model :activity-resource
     :cardinality :many}}

   :schema
   #:moment
   {:uuid
    {:doc "UUID of the moment"}}})
